import { render } from "./CreditHistory.vue?vue&type=template&id=57238246&scoped=true"
import script from "./CreditHistory.vue?vue&type=script&lang=js"
export * from "./CreditHistory.vue?vue&type=script&lang=js"

import "./CreditHistory.vue?vue&type=style&index=0&id=57238246&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57238246"

export default script